export default __webpack_public_path__ + "static/media/frg--sales-display.c9b7907d.png";